import { useEffect, useState } from 'react'
import { AddressInfo, customerData } from '../../utilities/CustomerData'
import { AdvancePaymentComplete } from './RefundCalculatedSteps/AdvancePaymentComplete'
import { RefundShippo } from './RefundCalculatedSteps/RefundShippo'
import { apiURL } from '../../utilities/URLs'
import { refreshAccessToken } from '../../utilities/extensions'
import { useNavigate } from 'react-router-dom'
import { RefundShippingOptions } from './RefundCalculatedSteps/RefundShippingOptions'
import { ConfirmCancelApplicationModal } from './ConfirmCancelApplicationModal'
import posthog from 'posthog-js'
import { RefundReadyCloud } from './RefundCalculatedSteps/RefundReadyCloud'

export default function AdvanceFundingApplication() {
  const navigate = useNavigate()
  const [application, setApplication] = useState(customerData.customerAdvanceFunding)
  const [step, setStep] = useState(customerData.customerAdvanceFunding.applicationStep < 2 ? (customerData.customerAdvanceFunding.blueInkPacketId ? 1 : 0) : customerData.customerAdvanceFunding.applicationStep)
  const [shippingOption, setShippingOption] = useState('')
  const [showConfirmCancelApplication, setShowConfirmCancelApplication] = useState(false)

  const handleAdvanceApplication = async () => {
    const advanceApplicationResponse = await fetch(`${apiURL}/api/updateApplicationStep?applicationId=${encodeURIComponent(application.applicationId)}`, {
      headers: {
        'Authorization': customerData.accessToken
      }
    })
    const advanceApplicationData = await advanceApplicationResponse.json()
    if (advanceApplicationData.response.error) {
      if (advanceApplicationData.response.error === 'Failed To Authenticate Token.') {
        const refreshedToken = await refreshAccessToken()
        refreshedToken && refreshedToken.length > 0 ? await handleAdvanceApplication() : navigate('/', { state: { expired: true } })
      } else
        console.error(advanceApplicationData.response.error)
    } else {
      customerData.customerAdvanceFunding.applicationStep += 1
      setStep(step + 1)
    }
  }

  useEffect(() => {
    posthog.startSessionRecording()

    return () => {
      posthog.stopSessionRecording()
    }
  }, [])

  return (
    <div className='w-screen flex flex-col items-center mt-4 font-robo'>
      <button onClick={() => setShowConfirmCancelApplication(true)} className='bg-red-600 hover:bg-red-700 text-white font-semibold py-2 px-4 rounded-lg shadow-md transition duration-300 ml-auto mr-5 max-sm:text-xs max-sm:mb-4'>
        Cancel Application
      </button>
      {step === 0 ? (
        shippingOption === '' ? (
          <RefundShippingOptions
            refundType={'Advance Funding'}
            step={step}
            setStep={setStep}
            setShippingOption={setShippingOption}
          />
        ) : shippingOption === 'Shippo' ? (
            <RefundShippo
              applicationId={application.applicationId}
              refundType={'Advance Funding'}
              step={step}
              setStep={setStep}
              setShippingOption={setShippingOption}
              handleGeneratedShippoLabel={handleAdvanceApplication}
            />
        ) : (
          <RefundReadyCloud 
            step={step}
            setStep={setStep}
          />
        )
      ) : (
        <AdvancePaymentComplete
          applicationId={application.applicationId}
        />
      )}
      {showConfirmCancelApplication && (
        <ConfirmCancelApplicationModal
          setShowConfirmCancelApplication={setShowConfirmCancelApplication}
        />
      )}
    </div>
  )
}